import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'
import createCollectionContext from 'modules/core/store/collections/CollectionContext'

import EmployeeStat from 'modules/attendance/store/models/EmployeeStat'
import Period from 'modules/attendance/store/models/Period'

class EmployeeStats extends Collection<EmployeeStat> {
  constructor(data: any = []) {
    super(data)
    makeObservable(this, {
      employeeIds: computed,
      approved: computed,
      pending: computed,
      inProgress: computed,
    })
  }

  get cacheKey(): string {
    return 'employeeStats'
  }

  model() {
    return EmployeeStat
  }

  get indexes() {
    return ['state']
  }

  get employeeIds(): number[] {
    return this.models.map((stat: EmployeeStat) => stat.get('employee_id'))
  }

  get approved(): EmployeeStat[] {
    return this.filter({
      state: Period.STATUS.approved,
    })
  }

  get pending(): EmployeeStat[] {
    return this.filter({
      state: Period.STATUS.pending,
    })
  }

  get inProgress(): EmployeeStat[] {
    return this.filter({
      state: Period.STATUS.in_progress,
    })
  }
}

const singleton: EmployeeStats = new EmployeeStats()

export default singleton

const { provider: EmployeeStatsProvider, hook: useEmployeeStats } = createCollectionContext<
  EmployeeStat,
  EmployeeStats
>()
